import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _2268fc73 = () => interopDefault(import('../pages/brand-directory.vue' /* webpackChunkName: "pages/brand-directory" */))
const _0486d69a = () => interopDefault(import('../pages/brands/index.vue' /* webpackChunkName: "pages/brands/index" */))
const _6a3c8084 = () => interopDefault(import('../pages/cart.vue' /* webpackChunkName: "pages/cart" */))
const _208189aa = () => interopDefault(import('../pages/checkout.vue' /* webpackChunkName: "pages/checkout" */))
const _13e8360f = () => interopDefault(import('../pages/checkout/address.vue' /* webpackChunkName: "pages/checkout/address" */))
const _0a2f7321 = () => interopDefault(import('../pages/checkout/payment.vue' /* webpackChunkName: "pages/checkout/payment" */))
const _4cde02c3 = () => interopDefault(import('../pages/home.vue' /* webpackChunkName: "" */))
const _56cd69b6 = () => interopDefault(import('../pages/ds/index.vue' /* webpackChunkName: "pages/ds/index" */))
const _dd1688ba = () => interopDefault(import('../pages/invite-retailers.vue' /* webpackChunkName: "pages/invite-retailers" */))
const _75111a89 = () => interopDefault(import('../pages/retailer-prisma.vue' /* webpackChunkName: "pages/retailer-prisma" */))
const _33adcbd6 = () => interopDefault(import('../pages/retailer-soennecken.vue' /* webpackChunkName: "pages/retailer-soennecken" */))
const _5fdbcadc = () => interopDefault(import('../pages/retailers/index.vue' /* webpackChunkName: "pages/retailers/index" */))
const _38d036ba = () => interopDefault(import('../pages/tica/index.vue' /* webpackChunkName: "pages/tica/index" */))
const _64323289 = () => interopDefault(import('../pages/trademart/index.vue' /* webpackChunkName: "pages/trademart/index" */))
const _2144ff52 = () => interopDefault(import('../pages/account/brands.vue' /* webpackChunkName: "pages/account/brands" */))
const _4e40a5d9 = () => interopDefault(import('../pages/account/channels/index.vue' /* webpackChunkName: "pages/account/channels/index" */))
const _764547e0 = () => interopDefault(import('../pages/account/edit.vue' /* webpackChunkName: "pages/account/edit" */))
const _6548ddc1 = () => interopDefault(import('../pages/account/favorites.vue' /* webpackChunkName: "pages/account/favorites" */))
const _806c4120 = () => interopDefault(import('../pages/account/inbox.vue' /* webpackChunkName: "pages/account/inbox" */))
const _daa615ca = () => interopDefault(import('../pages/account/inbox/_id.vue' /* webpackChunkName: "pages/account/inbox/_id" */))
const _7b285bec = () => interopDefault(import('../pages/account/invoices.vue' /* webpackChunkName: "pages/account/invoices" */))
const _c81a9ba4 = () => interopDefault(import('../pages/account/orders/index.vue' /* webpackChunkName: "pages/account/orders/index" */))
const _0ab0fbba = () => interopDefault(import('../pages/account/plus/index.vue' /* webpackChunkName: "pages/account/plus/index" */))
const _4f7559ce = () => interopDefault(import('../pages/account/tica.vue' /* webpackChunkName: "pages/account/tica" */))
const _7e867024 = () => interopDefault(import('../pages/account/trademart.vue' /* webpackChunkName: "pages/account/trademart" */))
const _40d12dca = () => interopDefault(import('../pages/ds/brands/index.vue' /* webpackChunkName: "pages/ds/brands/index" */))
const _650d0aa6 = () => interopDefault(import('../pages/ds/import-list/index.vue' /* webpackChunkName: "pages/ds/import-list/index" */))
const _03dd2d2c = () => interopDefault(import('../pages/ds/inbox.vue' /* webpackChunkName: "pages/ds/inbox" */))
const _246a1bd6 = () => interopDefault(import('../pages/ds/inbox/_id.vue' /* webpackChunkName: "pages/ds/inbox/_id" */))
const _02b4daf4 = () => interopDefault(import('../pages/ds/orders/index.vue' /* webpackChunkName: "pages/ds/orders/index" */))
const _5495d153 = () => interopDefault(import('../pages/ds/product-updates/index.vue' /* webpackChunkName: "pages/ds/product-updates/index" */))
const _100241b2 = () => interopDefault(import('../pages/ds/settings/index.vue' /* webpackChunkName: "pages/ds/settings/index" */))
const _7e3df532 = () => interopDefault(import('../pages/ds/signup/index.vue' /* webpackChunkName: "pages/ds/signup/index" */))
const _a090baac = () => interopDefault(import('../pages/ds/signup/index/index.vue' /* webpackChunkName: "pages/ds/signup/index/index" */))
const _5dfc1606 = () => interopDefault(import('../pages/ds/signup/index/waitinglist/index.vue' /* webpackChunkName: "pages/ds/signup/index/waitinglist/index" */))
const _055fd602 = () => interopDefault(import('../pages/ds/signup/index/select/_id.vue' /* webpackChunkName: "pages/ds/signup/index/select/_id" */))
const _00f83c24 = () => interopDefault(import('../pages/ds/signup/index/waitinglist/_id.vue' /* webpackChunkName: "pages/ds/signup/index/waitinglist/_id" */))
const _d82197a8 = () => interopDefault(import('../pages/ds/subscription/index.vue' /* webpackChunkName: "pages/ds/subscription/index" */))
const _279e6571 = () => interopDefault(import('../pages/tica/connected.vue' /* webpackChunkName: "pages/tica/connected" */))
const _4b98fc5e = () => interopDefault(import('../pages/account/plus/subscribe/index.vue' /* webpackChunkName: "pages/account/plus/subscribe/index" */))
const _4b9adf42 = () => interopDefault(import('../pages/ds/orders/new.vue' /* webpackChunkName: "pages/ds/orders/new" */))
const _3af9cb8d = () => interopDefault(import('../pages/ds/settings/account.vue' /* webpackChunkName: "pages/ds/settings/account" */))
const _43c60e94 = () => interopDefault(import('../pages/ds/settings/countries.vue' /* webpackChunkName: "pages/ds/settings/countries" */))
const _605046f2 = () => interopDefault(import('../pages/ds/settings/mail.vue' /* webpackChunkName: "pages/ds/settings/mail" */))
const _261bded8 = () => interopDefault(import('../pages/ds/settings/preferences.vue' /* webpackChunkName: "pages/ds/settings/preferences" */))
const _e993b712 = () => interopDefault(import('../pages/ds/settings/software.vue' /* webpackChunkName: "pages/ds/settings/software" */))
const _04a7239d = () => interopDefault(import('../pages/ds/signup/error.vue' /* webpackChunkName: "pages/ds/signup/error" */))
const _092fcd3e = () => interopDefault(import('../pages/ds/subscription/paymentMethod.vue' /* webpackChunkName: "pages/ds/subscription/paymentMethod" */))
const _0fc2fe46 = () => interopDefault(import('../pages/ds/subscription/return.vue' /* webpackChunkName: "pages/ds/subscription/return" */))
const _52c9d607 = () => interopDefault(import('../pages/ds/subscription/update-plan.vue' /* webpackChunkName: "pages/ds/subscription/update-plan" */))
const _4d523c54 = () => interopDefault(import('../pages/account/plus/subscribe/return.vue' /* webpackChunkName: "pages/account/plus/subscribe/return" */))
const _6d404a81 = () => interopDefault(import('../pages/account/channels/_id.vue' /* webpackChunkName: "pages/account/channels/_id" */))
const _cea9f3ce = () => interopDefault(import('../pages/account/orders/_id/index.vue' /* webpackChunkName: "pages/account/orders/_id/index" */))
const _37e50a5c = () => interopDefault(import('../pages/ds/orders/_id.vue' /* webpackChunkName: "pages/ds/orders/_id" */))
const _2bfe0c7b = () => interopDefault(import('../pages/ds/product-updates/_id.vue' /* webpackChunkName: "pages/ds/product-updates/_id" */))
const _3ce548aa = () => interopDefault(import('../pages/order/direct/_token.vue' /* webpackChunkName: "pages/order/direct/_token" */))
const _4d418a2a = () => interopDefault(import('../pages/tica/invites/_token/index.vue' /* webpackChunkName: "pages/tica/invites/_token/index" */))
const _3d3c967b = () => interopDefault(import('../pages/trademart/invites/_token/index.vue' /* webpackChunkName: "pages/trademart/invites/_token/index" */))
const _ec80cfd8 = () => interopDefault(import('../pages/account/orders/_id/updates/index.vue' /* webpackChunkName: "pages/account/orders/_id/updates/index" */))
const _1c7786bf = () => interopDefault(import('../pages/ds/orders/_token/payment.vue' /* webpackChunkName: "pages/ds/orders/_token/payment" */))
const _217cd37e = () => interopDefault(import('../pages/ds/store/_slug/about.vue' /* webpackChunkName: "pages/ds/store/_slug/about" */))
const _043bac7a = () => interopDefault(import('../pages/ds/orders/_token/return/_paymentId.vue' /* webpackChunkName: "pages/ds/orders/_token/return/_paymentId" */))
const _5a72fb91 = () => interopDefault(import('../pages/ds/store/_slug/listings/_listingId.vue' /* webpackChunkName: "pages/ds/store/_slug/listings/_listingId" */))
const _15ca84a2 = () => interopDefault(import('../pages/ds/marketplace.vue' /* webpackChunkName: "" */))
const _4134ae43 = () => interopDefault(import('../pages/ds/store/_slug/index.vue' /* webpackChunkName: "" */))
const _30cd7aed = () => interopDefault(import('../pages/tica/invites/_token/connect/_id.vue' /* webpackChunkName: "pages/tica/invites/_token/connect/_id" */))
const _ffaf7304 = () => interopDefault(import('../pages/trademart/invites/_token/connect/_id.vue' /* webpackChunkName: "pages/trademart/invites/_token/connect/_id" */))
const _0af3b87a = () => interopDefault(import('../pages/brands/_type.vue' /* webpackChunkName: "pages/brands/_type" */))
const _73fad1fe = () => interopDefault(import('../pages/email-settings/_token.vue' /* webpackChunkName: "pages/email-settings/_token" */))
const _cb1f3282 = () => interopDefault(import('../pages/order/_token.vue' /* webpackChunkName: "pages/order/_token" */))
const _5dfe61b5 = () => interopDefault(import('../pages/order/_token/confirmation.vue' /* webpackChunkName: "pages/order/_token/confirmation" */))
const _18e32994 = () => interopDefault(import('../pages/order/_token/payment.vue' /* webpackChunkName: "pages/order/_token/payment" */))
const _59c880db = () => interopDefault(import('../pages/order/_token/return/_id.vue' /* webpackChunkName: "pages/order/_token/return/_id" */))
const _a438c924 = () => interopDefault(import('../pages/page/_slug.vue' /* webpackChunkName: "pages/page/_slug" */))
const _a3457da2 = () => interopDefault(import('../pages/pay/_slug.vue' /* webpackChunkName: "pages/pay/_slug" */))
const _456d834e = () => interopDefault(import('../pages/retailers/_type.vue' /* webpackChunkName: "pages/retailers/_type" */))
const _763b26e6 = () => interopDefault(import('../pages/store/_slug/about.vue' /* webpackChunkName: "pages/store/_slug/about" */))
const _3fd83ee2 = () => interopDefault(import('../pages/store/_slug/signup.vue' /* webpackChunkName: "pages/store/_slug/signup" */))
const _49dce10c = () => interopDefault(import('../pages/store/_slug/write-review/_orderId.vue' /* webpackChunkName: "pages/store/_slug/write-review/_orderId" */))
const _035481d2 = () => interopDefault(import('../pages/marketplace.vue' /* webpackChunkName: "" */))
const _d419fcaa = () => interopDefault(import('../pages/store/_slug/index.vue' /* webpackChunkName: "" */))
const _96f4d604 = () => interopDefault(import('../pages/store/listings/_listingId.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/brand-directory",
    component: _2268fc73,
    name: "brand-directory___en"
  }, {
    path: "/brands",
    component: _0486d69a,
    name: "brands___en"
  }, {
    path: "/cart",
    component: _6a3c8084,
    name: "cart___en"
  }, {
    path: "/checkout",
    component: _208189aa,
    name: "checkout___en",
    children: [{
      path: "address",
      component: _13e8360f,
      name: "checkout-address___en"
    }, {
      path: "payment",
      component: _0a2f7321,
      name: "checkout-payment___en"
    }]
  }, {
    path: "/da",
    component: _4cde02c3,
    name: "home___da"
  }, {
    path: "/de",
    component: _4cde02c3,
    name: "home___de"
  }, {
    path: "/ds",
    component: _56cd69b6,
    name: "ds___en"
  }, {
    path: "/es",
    component: _4cde02c3,
    name: "home___es"
  }, {
    path: "/fr",
    component: _4cde02c3,
    name: "home___fr"
  }, {
    path: "/invite-retailers",
    component: _dd1688ba,
    name: "invite-retailers___en"
  }, {
    path: "/it",
    component: _4cde02c3,
    name: "home___it"
  }, {
    path: "/nl",
    component: _4cde02c3,
    name: "home___nl"
  }, {
    path: "/pl",
    component: _4cde02c3,
    name: "home___pl"
  }, {
    path: "/retailer-prisma",
    component: _75111a89,
    name: "retailer-prisma___en"
  }, {
    path: "/retailer-soennecken",
    component: _33adcbd6,
    name: "retailer-soennecken___en"
  }, {
    path: "/retailers",
    component: _5fdbcadc,
    name: "retailers___en"
  }, {
    path: "/tica",
    component: _38d036ba,
    name: "tica___en"
  }, {
    path: "/trademart",
    component: _64323289,
    name: "trademart___en"
  }, {
    path: "/account/brands",
    component: _2144ff52,
    name: "account-brands___en"
  }, {
    path: "/account/channels",
    component: _4e40a5d9,
    name: "account-channels___en"
  }, {
    path: "/account/edit",
    component: _764547e0,
    name: "account-edit___en"
  }, {
    path: "/account/favorites",
    component: _6548ddc1,
    name: "account-favorites___en"
  }, {
    path: "/account/inbox",
    component: _806c4120,
    name: "account-inbox___en",
    children: [{
      path: ":id?",
      component: _daa615ca,
      name: "account-inbox-id___en"
    }]
  }, {
    path: "/account/invoices",
    component: _7b285bec,
    name: "account-invoices___en"
  }, {
    path: "/account/orders",
    component: _c81a9ba4,
    name: "account-orders___en"
  }, {
    path: "/account/plus",
    component: _0ab0fbba,
    name: "account-plus___en"
  }, {
    path: "/account/tica",
    component: _4f7559ce,
    name: "account-tica___en"
  }, {
    path: "/account/trademart",
    component: _7e867024,
    name: "account-trademart___en"
  }, {
    path: "/da/brand-directory",
    component: _2268fc73,
    name: "brand-directory___da"
  }, {
    path: "/da/brands",
    component: _0486d69a,
    name: "brands___da"
  }, {
    path: "/da/cart",
    component: _6a3c8084,
    name: "cart___da"
  }, {
    path: "/da/checkout",
    component: _208189aa,
    name: "checkout___da",
    children: [{
      path: "address",
      component: _13e8360f,
      name: "checkout-address___da"
    }, {
      path: "payment",
      component: _0a2f7321,
      name: "checkout-payment___da"
    }]
  }, {
    path: "/da/ds",
    component: _56cd69b6,
    name: "ds___da"
  }, {
    path: "/da/invite-retailers",
    component: _dd1688ba,
    name: "invite-retailers___da"
  }, {
    path: "/da/retailer-prisma",
    component: _75111a89,
    name: "retailer-prisma___da"
  }, {
    path: "/da/retailer-soennecken",
    component: _33adcbd6,
    name: "retailer-soennecken___da"
  }, {
    path: "/da/retailers",
    component: _5fdbcadc,
    name: "retailers___da"
  }, {
    path: "/da/tica",
    component: _38d036ba,
    name: "tica___da"
  }, {
    path: "/da/trademart",
    component: _64323289,
    name: "trademart___da"
  }, {
    path: "/de/brand-directory",
    component: _2268fc73,
    name: "brand-directory___de"
  }, {
    path: "/de/brands",
    component: _0486d69a,
    name: "brands___de"
  }, {
    path: "/de/cart",
    component: _6a3c8084,
    name: "cart___de"
  }, {
    path: "/de/checkout",
    component: _208189aa,
    name: "checkout___de",
    children: [{
      path: "address",
      component: _13e8360f,
      name: "checkout-address___de"
    }, {
      path: "payment",
      component: _0a2f7321,
      name: "checkout-payment___de"
    }]
  }, {
    path: "/de/ds",
    component: _56cd69b6,
    name: "ds___de"
  }, {
    path: "/de/invite-retailers",
    component: _dd1688ba,
    name: "invite-retailers___de"
  }, {
    path: "/de/retailer-prisma",
    component: _75111a89,
    name: "retailer-prisma___de"
  }, {
    path: "/de/retailer-soennecken",
    component: _33adcbd6,
    name: "retailer-soennecken___de"
  }, {
    path: "/de/retailers",
    component: _5fdbcadc,
    name: "retailers___de"
  }, {
    path: "/de/tica",
    component: _38d036ba,
    name: "tica___de"
  }, {
    path: "/de/trademart",
    component: _64323289,
    name: "trademart___de"
  }, {
    path: "/ds/brands",
    component: _40d12dca,
    name: "ds-brands___en"
  }, {
    path: "/ds/import-list",
    component: _650d0aa6,
    name: "ds-import-list___en"
  }, {
    path: "/ds/inbox",
    component: _03dd2d2c,
    name: "ds-inbox___en",
    children: [{
      path: ":id?",
      component: _246a1bd6,
      name: "ds-inbox-id___en"
    }]
  }, {
    path: "/ds/orders",
    component: _02b4daf4,
    name: "ds-orders___en"
  }, {
    path: "/ds/product-updates",
    component: _5495d153,
    name: "ds-product-updates___en"
  }, {
    path: "/ds/settings",
    component: _100241b2,
    name: "ds-settings___en"
  }, {
    path: "/ds/signup",
    component: _7e3df532,
    children: [{
      path: "",
      component: _a090baac,
      name: "ds-signup-index___en"
    }, {
      path: "waitinglist",
      component: _5dfc1606,
      name: "ds-signup-index-waitinglist___en"
    }, {
      path: "select/:id?",
      component: _055fd602,
      name: "ds-signup-index-select-id___en"
    }, {
      path: "waitinglist/:id?",
      component: _00f83c24,
      name: "ds-signup-index-waitinglist-id___en"
    }]
  }, {
    path: "/ds/subscription",
    component: _d82197a8,
    name: "ds-subscription___en"
  }, {
    path: "/es/brand-directory",
    component: _2268fc73,
    name: "brand-directory___es"
  }, {
    path: "/es/brands",
    component: _0486d69a,
    name: "brands___es"
  }, {
    path: "/es/cart",
    component: _6a3c8084,
    name: "cart___es"
  }, {
    path: "/es/checkout",
    component: _208189aa,
    name: "checkout___es",
    children: [{
      path: "address",
      component: _13e8360f,
      name: "checkout-address___es"
    }, {
      path: "payment",
      component: _0a2f7321,
      name: "checkout-payment___es"
    }]
  }, {
    path: "/es/ds",
    component: _56cd69b6,
    name: "ds___es"
  }, {
    path: "/es/invite-retailers",
    component: _dd1688ba,
    name: "invite-retailers___es"
  }, {
    path: "/es/retailer-prisma",
    component: _75111a89,
    name: "retailer-prisma___es"
  }, {
    path: "/es/retailer-soennecken",
    component: _33adcbd6,
    name: "retailer-soennecken___es"
  }, {
    path: "/es/retailers",
    component: _5fdbcadc,
    name: "retailers___es"
  }, {
    path: "/es/tica",
    component: _38d036ba,
    name: "tica___es"
  }, {
    path: "/es/trademart",
    component: _64323289,
    name: "trademart___es"
  }, {
    path: "/fr/brand-directory",
    component: _2268fc73,
    name: "brand-directory___fr"
  }, {
    path: "/fr/brands",
    component: _0486d69a,
    name: "brands___fr"
  }, {
    path: "/fr/cart",
    component: _6a3c8084,
    name: "cart___fr"
  }, {
    path: "/fr/checkout",
    component: _208189aa,
    name: "checkout___fr",
    children: [{
      path: "address",
      component: _13e8360f,
      name: "checkout-address___fr"
    }, {
      path: "payment",
      component: _0a2f7321,
      name: "checkout-payment___fr"
    }]
  }, {
    path: "/fr/ds",
    component: _56cd69b6,
    name: "ds___fr"
  }, {
    path: "/fr/invite-retailers",
    component: _dd1688ba,
    name: "invite-retailers___fr"
  }, {
    path: "/fr/retailer-prisma",
    component: _75111a89,
    name: "retailer-prisma___fr"
  }, {
    path: "/fr/retailer-soennecken",
    component: _33adcbd6,
    name: "retailer-soennecken___fr"
  }, {
    path: "/fr/retailers",
    component: _5fdbcadc,
    name: "retailers___fr"
  }, {
    path: "/fr/tica",
    component: _38d036ba,
    name: "tica___fr"
  }, {
    path: "/fr/trademart",
    component: _64323289,
    name: "trademart___fr"
  }, {
    path: "/it/brand-directory",
    component: _2268fc73,
    name: "brand-directory___it"
  }, {
    path: "/it/brands",
    component: _0486d69a,
    name: "brands___it"
  }, {
    path: "/it/cart",
    component: _6a3c8084,
    name: "cart___it"
  }, {
    path: "/it/checkout",
    component: _208189aa,
    name: "checkout___it",
    children: [{
      path: "address",
      component: _13e8360f,
      name: "checkout-address___it"
    }, {
      path: "payment",
      component: _0a2f7321,
      name: "checkout-payment___it"
    }]
  }, {
    path: "/it/ds",
    component: _56cd69b6,
    name: "ds___it"
  }, {
    path: "/it/invite-retailers",
    component: _dd1688ba,
    name: "invite-retailers___it"
  }, {
    path: "/it/retailer-prisma",
    component: _75111a89,
    name: "retailer-prisma___it"
  }, {
    path: "/it/retailer-soennecken",
    component: _33adcbd6,
    name: "retailer-soennecken___it"
  }, {
    path: "/it/retailers",
    component: _5fdbcadc,
    name: "retailers___it"
  }, {
    path: "/it/tica",
    component: _38d036ba,
    name: "tica___it"
  }, {
    path: "/it/trademart",
    component: _64323289,
    name: "trademart___it"
  }, {
    path: "/nl/brand-directory",
    component: _2268fc73,
    name: "brand-directory___nl"
  }, {
    path: "/nl/brands",
    component: _0486d69a,
    name: "brands___nl"
  }, {
    path: "/nl/cart",
    component: _6a3c8084,
    name: "cart___nl"
  }, {
    path: "/nl/checkout",
    component: _208189aa,
    name: "checkout___nl",
    children: [{
      path: "address",
      component: _13e8360f,
      name: "checkout-address___nl"
    }, {
      path: "payment",
      component: _0a2f7321,
      name: "checkout-payment___nl"
    }]
  }, {
    path: "/nl/ds",
    component: _56cd69b6,
    name: "ds___nl"
  }, {
    path: "/nl/invite-retailers",
    component: _dd1688ba,
    name: "invite-retailers___nl"
  }, {
    path: "/nl/retailer-prisma",
    component: _75111a89,
    name: "retailer-prisma___nl"
  }, {
    path: "/nl/retailer-soennecken",
    component: _33adcbd6,
    name: "retailer-soennecken___nl"
  }, {
    path: "/nl/retailers",
    component: _5fdbcadc,
    name: "retailers___nl"
  }, {
    path: "/nl/tica",
    component: _38d036ba,
    name: "tica___nl"
  }, {
    path: "/nl/trademart",
    component: _64323289,
    name: "trademart___nl"
  }, {
    path: "/pl/brand-directory",
    component: _2268fc73,
    name: "brand-directory___pl"
  }, {
    path: "/pl/brands",
    component: _0486d69a,
    name: "brands___pl"
  }, {
    path: "/pl/cart",
    component: _6a3c8084,
    name: "cart___pl"
  }, {
    path: "/pl/checkout",
    component: _208189aa,
    name: "checkout___pl",
    children: [{
      path: "address",
      component: _13e8360f,
      name: "checkout-address___pl"
    }, {
      path: "payment",
      component: _0a2f7321,
      name: "checkout-payment___pl"
    }]
  }, {
    path: "/pl/ds",
    component: _56cd69b6,
    name: "ds___pl"
  }, {
    path: "/pl/invite-retailers",
    component: _dd1688ba,
    name: "invite-retailers___pl"
  }, {
    path: "/pl/retailer-prisma",
    component: _75111a89,
    name: "retailer-prisma___pl"
  }, {
    path: "/pl/retailer-soennecken",
    component: _33adcbd6,
    name: "retailer-soennecken___pl"
  }, {
    path: "/pl/retailers",
    component: _5fdbcadc,
    name: "retailers___pl"
  }, {
    path: "/pl/tica",
    component: _38d036ba,
    name: "tica___pl"
  }, {
    path: "/pl/trademart",
    component: _64323289,
    name: "trademart___pl"
  }, {
    path: "/tica/connected",
    component: _279e6571,
    name: "tica-connected___en"
  }, {
    path: "/account/plus/subscribe",
    component: _4b98fc5e,
    name: "account-plus-subscribe___en"
  }, {
    path: "/da/account/brands",
    component: _2144ff52,
    name: "account-brands___da"
  }, {
    path: "/da/account/channels",
    component: _4e40a5d9,
    name: "account-channels___da"
  }, {
    path: "/da/account/edit",
    component: _764547e0,
    name: "account-edit___da"
  }, {
    path: "/da/account/favorites",
    component: _6548ddc1,
    name: "account-favorites___da"
  }, {
    path: "/da/account/inbox",
    component: _806c4120,
    name: "account-inbox___da",
    children: [{
      path: ":id?",
      component: _daa615ca,
      name: "account-inbox-id___da"
    }]
  }, {
    path: "/da/account/invoices",
    component: _7b285bec,
    name: "account-invoices___da"
  }, {
    path: "/da/account/orders",
    component: _c81a9ba4,
    name: "account-orders___da"
  }, {
    path: "/da/account/plus",
    component: _0ab0fbba,
    name: "account-plus___da"
  }, {
    path: "/da/account/tica",
    component: _4f7559ce,
    name: "account-tica___da"
  }, {
    path: "/da/account/trademart",
    component: _7e867024,
    name: "account-trademart___da"
  }, {
    path: "/da/ds/brands",
    component: _40d12dca,
    name: "ds-brands___da"
  }, {
    path: "/da/ds/import-list",
    component: _650d0aa6,
    name: "ds-import-list___da"
  }, {
    path: "/da/ds/inbox",
    component: _03dd2d2c,
    name: "ds-inbox___da",
    children: [{
      path: ":id?",
      component: _246a1bd6,
      name: "ds-inbox-id___da"
    }]
  }, {
    path: "/da/ds/orders",
    component: _02b4daf4,
    name: "ds-orders___da"
  }, {
    path: "/da/ds/product-updates",
    component: _5495d153,
    name: "ds-product-updates___da"
  }, {
    path: "/da/ds/settings",
    component: _100241b2,
    name: "ds-settings___da"
  }, {
    path: "/da/ds/signup",
    component: _7e3df532,
    children: [{
      path: "",
      component: _a090baac,
      name: "ds-signup-index___da"
    }, {
      path: "waitinglist",
      component: _5dfc1606,
      name: "ds-signup-index-waitinglist___da"
    }, {
      path: "select/:id?",
      component: _055fd602,
      name: "ds-signup-index-select-id___da"
    }, {
      path: "waitinglist/:id?",
      component: _00f83c24,
      name: "ds-signup-index-waitinglist-id___da"
    }]
  }, {
    path: "/da/ds/subscription",
    component: _d82197a8,
    name: "ds-subscription___da"
  }, {
    path: "/da/tica/connected",
    component: _279e6571,
    name: "tica-connected___da"
  }, {
    path: "/de/account/brands",
    component: _2144ff52,
    name: "account-brands___de"
  }, {
    path: "/de/account/channels",
    component: _4e40a5d9,
    name: "account-channels___de"
  }, {
    path: "/de/account/edit",
    component: _764547e0,
    name: "account-edit___de"
  }, {
    path: "/de/account/favorites",
    component: _6548ddc1,
    name: "account-favorites___de"
  }, {
    path: "/de/account/inbox",
    component: _806c4120,
    name: "account-inbox___de",
    children: [{
      path: ":id?",
      component: _daa615ca,
      name: "account-inbox-id___de"
    }]
  }, {
    path: "/de/account/invoices",
    component: _7b285bec,
    name: "account-invoices___de"
  }, {
    path: "/de/account/orders",
    component: _c81a9ba4,
    name: "account-orders___de"
  }, {
    path: "/de/account/plus",
    component: _0ab0fbba,
    name: "account-plus___de"
  }, {
    path: "/de/account/tica",
    component: _4f7559ce,
    name: "account-tica___de"
  }, {
    path: "/de/account/trademart",
    component: _7e867024,
    name: "account-trademart___de"
  }, {
    path: "/de/ds/brands",
    component: _40d12dca,
    name: "ds-brands___de"
  }, {
    path: "/de/ds/import-list",
    component: _650d0aa6,
    name: "ds-import-list___de"
  }, {
    path: "/de/ds/inbox",
    component: _03dd2d2c,
    name: "ds-inbox___de",
    children: [{
      path: ":id?",
      component: _246a1bd6,
      name: "ds-inbox-id___de"
    }]
  }, {
    path: "/de/ds/orders",
    component: _02b4daf4,
    name: "ds-orders___de"
  }, {
    path: "/de/ds/product-updates",
    component: _5495d153,
    name: "ds-product-updates___de"
  }, {
    path: "/de/ds/settings",
    component: _100241b2,
    name: "ds-settings___de"
  }, {
    path: "/de/ds/signup",
    component: _7e3df532,
    children: [{
      path: "",
      component: _a090baac,
      name: "ds-signup-index___de"
    }, {
      path: "waitinglist",
      component: _5dfc1606,
      name: "ds-signup-index-waitinglist___de"
    }, {
      path: "select/:id?",
      component: _055fd602,
      name: "ds-signup-index-select-id___de"
    }, {
      path: "waitinglist/:id?",
      component: _00f83c24,
      name: "ds-signup-index-waitinglist-id___de"
    }]
  }, {
    path: "/de/ds/subscription",
    component: _d82197a8,
    name: "ds-subscription___de"
  }, {
    path: "/de/tica/connected",
    component: _279e6571,
    name: "tica-connected___de"
  }, {
    path: "/ds/orders/new",
    component: _4b9adf42,
    name: "ds-orders-new___en"
  }, {
    path: "/ds/settings/account",
    component: _3af9cb8d,
    name: "ds-settings-account___en"
  }, {
    path: "/ds/settings/countries",
    component: _43c60e94,
    name: "ds-settings-countries___en"
  }, {
    path: "/ds/settings/mail",
    component: _605046f2,
    name: "ds-settings-mail___en"
  }, {
    path: "/ds/settings/preferences",
    component: _261bded8,
    name: "ds-settings-preferences___en"
  }, {
    path: "/ds/settings/software",
    component: _e993b712,
    name: "ds-settings-software___en"
  }, {
    path: "/ds/signup/error",
    component: _04a7239d,
    name: "ds-signup-error___en"
  }, {
    path: "/ds/subscription/paymentMethod",
    component: _092fcd3e,
    name: "ds-subscription-paymentMethod___en"
  }, {
    path: "/ds/subscription/return",
    component: _0fc2fe46,
    name: "ds-subscription-return___en"
  }, {
    path: "/ds/subscription/update-plan",
    component: _52c9d607,
    name: "ds-subscription-update-plan___en"
  }, {
    path: "/es/account/brands",
    component: _2144ff52,
    name: "account-brands___es"
  }, {
    path: "/es/account/channels",
    component: _4e40a5d9,
    name: "account-channels___es"
  }, {
    path: "/es/account/edit",
    component: _764547e0,
    name: "account-edit___es"
  }, {
    path: "/es/account/favorites",
    component: _6548ddc1,
    name: "account-favorites___es"
  }, {
    path: "/es/account/inbox",
    component: _806c4120,
    name: "account-inbox___es",
    children: [{
      path: ":id?",
      component: _daa615ca,
      name: "account-inbox-id___es"
    }]
  }, {
    path: "/es/account/invoices",
    component: _7b285bec,
    name: "account-invoices___es"
  }, {
    path: "/es/account/orders",
    component: _c81a9ba4,
    name: "account-orders___es"
  }, {
    path: "/es/account/plus",
    component: _0ab0fbba,
    name: "account-plus___es"
  }, {
    path: "/es/account/tica",
    component: _4f7559ce,
    name: "account-tica___es"
  }, {
    path: "/es/account/trademart",
    component: _7e867024,
    name: "account-trademart___es"
  }, {
    path: "/es/ds/brands",
    component: _40d12dca,
    name: "ds-brands___es"
  }, {
    path: "/es/ds/import-list",
    component: _650d0aa6,
    name: "ds-import-list___es"
  }, {
    path: "/es/ds/inbox",
    component: _03dd2d2c,
    name: "ds-inbox___es",
    children: [{
      path: ":id?",
      component: _246a1bd6,
      name: "ds-inbox-id___es"
    }]
  }, {
    path: "/es/ds/orders",
    component: _02b4daf4,
    name: "ds-orders___es"
  }, {
    path: "/es/ds/product-updates",
    component: _5495d153,
    name: "ds-product-updates___es"
  }, {
    path: "/es/ds/settings",
    component: _100241b2,
    name: "ds-settings___es"
  }, {
    path: "/es/ds/signup",
    component: _7e3df532,
    children: [{
      path: "",
      component: _a090baac,
      name: "ds-signup-index___es"
    }, {
      path: "waitinglist",
      component: _5dfc1606,
      name: "ds-signup-index-waitinglist___es"
    }, {
      path: "select/:id?",
      component: _055fd602,
      name: "ds-signup-index-select-id___es"
    }, {
      path: "waitinglist/:id?",
      component: _00f83c24,
      name: "ds-signup-index-waitinglist-id___es"
    }]
  }, {
    path: "/es/ds/subscription",
    component: _d82197a8,
    name: "ds-subscription___es"
  }, {
    path: "/es/tica/connected",
    component: _279e6571,
    name: "tica-connected___es"
  }, {
    path: "/fr/account/brands",
    component: _2144ff52,
    name: "account-brands___fr"
  }, {
    path: "/fr/account/channels",
    component: _4e40a5d9,
    name: "account-channels___fr"
  }, {
    path: "/fr/account/edit",
    component: _764547e0,
    name: "account-edit___fr"
  }, {
    path: "/fr/account/favorites",
    component: _6548ddc1,
    name: "account-favorites___fr"
  }, {
    path: "/fr/account/inbox",
    component: _806c4120,
    name: "account-inbox___fr",
    children: [{
      path: ":id?",
      component: _daa615ca,
      name: "account-inbox-id___fr"
    }]
  }, {
    path: "/fr/account/invoices",
    component: _7b285bec,
    name: "account-invoices___fr"
  }, {
    path: "/fr/account/orders",
    component: _c81a9ba4,
    name: "account-orders___fr"
  }, {
    path: "/fr/account/plus",
    component: _0ab0fbba,
    name: "account-plus___fr"
  }, {
    path: "/fr/account/tica",
    component: _4f7559ce,
    name: "account-tica___fr"
  }, {
    path: "/fr/account/trademart",
    component: _7e867024,
    name: "account-trademart___fr"
  }, {
    path: "/fr/ds/brands",
    component: _40d12dca,
    name: "ds-brands___fr"
  }, {
    path: "/fr/ds/import-list",
    component: _650d0aa6,
    name: "ds-import-list___fr"
  }, {
    path: "/fr/ds/inbox",
    component: _03dd2d2c,
    name: "ds-inbox___fr",
    children: [{
      path: ":id?",
      component: _246a1bd6,
      name: "ds-inbox-id___fr"
    }]
  }, {
    path: "/fr/ds/orders",
    component: _02b4daf4,
    name: "ds-orders___fr"
  }, {
    path: "/fr/ds/product-updates",
    component: _5495d153,
    name: "ds-product-updates___fr"
  }, {
    path: "/fr/ds/settings",
    component: _100241b2,
    name: "ds-settings___fr"
  }, {
    path: "/fr/ds/signup",
    component: _7e3df532,
    children: [{
      path: "",
      component: _a090baac,
      name: "ds-signup-index___fr"
    }, {
      path: "waitinglist",
      component: _5dfc1606,
      name: "ds-signup-index-waitinglist___fr"
    }, {
      path: "select/:id?",
      component: _055fd602,
      name: "ds-signup-index-select-id___fr"
    }, {
      path: "waitinglist/:id?",
      component: _00f83c24,
      name: "ds-signup-index-waitinglist-id___fr"
    }]
  }, {
    path: "/fr/ds/subscription",
    component: _d82197a8,
    name: "ds-subscription___fr"
  }, {
    path: "/fr/tica/connected",
    component: _279e6571,
    name: "tica-connected___fr"
  }, {
    path: "/it/account/brands",
    component: _2144ff52,
    name: "account-brands___it"
  }, {
    path: "/it/account/channels",
    component: _4e40a5d9,
    name: "account-channels___it"
  }, {
    path: "/it/account/edit",
    component: _764547e0,
    name: "account-edit___it"
  }, {
    path: "/it/account/favorites",
    component: _6548ddc1,
    name: "account-favorites___it"
  }, {
    path: "/it/account/inbox",
    component: _806c4120,
    name: "account-inbox___it",
    children: [{
      path: ":id?",
      component: _daa615ca,
      name: "account-inbox-id___it"
    }]
  }, {
    path: "/it/account/invoices",
    component: _7b285bec,
    name: "account-invoices___it"
  }, {
    path: "/it/account/orders",
    component: _c81a9ba4,
    name: "account-orders___it"
  }, {
    path: "/it/account/plus",
    component: _0ab0fbba,
    name: "account-plus___it"
  }, {
    path: "/it/account/tica",
    component: _4f7559ce,
    name: "account-tica___it"
  }, {
    path: "/it/account/trademart",
    component: _7e867024,
    name: "account-trademart___it"
  }, {
    path: "/it/ds/brands",
    component: _40d12dca,
    name: "ds-brands___it"
  }, {
    path: "/it/ds/import-list",
    component: _650d0aa6,
    name: "ds-import-list___it"
  }, {
    path: "/it/ds/inbox",
    component: _03dd2d2c,
    name: "ds-inbox___it",
    children: [{
      path: ":id?",
      component: _246a1bd6,
      name: "ds-inbox-id___it"
    }]
  }, {
    path: "/it/ds/orders",
    component: _02b4daf4,
    name: "ds-orders___it"
  }, {
    path: "/it/ds/product-updates",
    component: _5495d153,
    name: "ds-product-updates___it"
  }, {
    path: "/it/ds/settings",
    component: _100241b2,
    name: "ds-settings___it"
  }, {
    path: "/it/ds/signup",
    component: _7e3df532,
    children: [{
      path: "",
      component: _a090baac,
      name: "ds-signup-index___it"
    }, {
      path: "waitinglist",
      component: _5dfc1606,
      name: "ds-signup-index-waitinglist___it"
    }, {
      path: "select/:id?",
      component: _055fd602,
      name: "ds-signup-index-select-id___it"
    }, {
      path: "waitinglist/:id?",
      component: _00f83c24,
      name: "ds-signup-index-waitinglist-id___it"
    }]
  }, {
    path: "/it/ds/subscription",
    component: _d82197a8,
    name: "ds-subscription___it"
  }, {
    path: "/it/tica/connected",
    component: _279e6571,
    name: "tica-connected___it"
  }, {
    path: "/nl/account/brands",
    component: _2144ff52,
    name: "account-brands___nl"
  }, {
    path: "/nl/account/channels",
    component: _4e40a5d9,
    name: "account-channels___nl"
  }, {
    path: "/nl/account/edit",
    component: _764547e0,
    name: "account-edit___nl"
  }, {
    path: "/nl/account/favorites",
    component: _6548ddc1,
    name: "account-favorites___nl"
  }, {
    path: "/nl/account/inbox",
    component: _806c4120,
    name: "account-inbox___nl",
    children: [{
      path: ":id?",
      component: _daa615ca,
      name: "account-inbox-id___nl"
    }]
  }, {
    path: "/nl/account/invoices",
    component: _7b285bec,
    name: "account-invoices___nl"
  }, {
    path: "/nl/account/orders",
    component: _c81a9ba4,
    name: "account-orders___nl"
  }, {
    path: "/nl/account/plus",
    component: _0ab0fbba,
    name: "account-plus___nl"
  }, {
    path: "/nl/account/tica",
    component: _4f7559ce,
    name: "account-tica___nl"
  }, {
    path: "/nl/account/trademart",
    component: _7e867024,
    name: "account-trademart___nl"
  }, {
    path: "/nl/ds/brands",
    component: _40d12dca,
    name: "ds-brands___nl"
  }, {
    path: "/nl/ds/import-list",
    component: _650d0aa6,
    name: "ds-import-list___nl"
  }, {
    path: "/nl/ds/inbox",
    component: _03dd2d2c,
    name: "ds-inbox___nl",
    children: [{
      path: ":id?",
      component: _246a1bd6,
      name: "ds-inbox-id___nl"
    }]
  }, {
    path: "/nl/ds/orders",
    component: _02b4daf4,
    name: "ds-orders___nl"
  }, {
    path: "/nl/ds/product-updates",
    component: _5495d153,
    name: "ds-product-updates___nl"
  }, {
    path: "/nl/ds/settings",
    component: _100241b2,
    name: "ds-settings___nl"
  }, {
    path: "/nl/ds/signup",
    component: _7e3df532,
    children: [{
      path: "",
      component: _a090baac,
      name: "ds-signup-index___nl"
    }, {
      path: "waitinglist",
      component: _5dfc1606,
      name: "ds-signup-index-waitinglist___nl"
    }, {
      path: "select/:id?",
      component: _055fd602,
      name: "ds-signup-index-select-id___nl"
    }, {
      path: "waitinglist/:id?",
      component: _00f83c24,
      name: "ds-signup-index-waitinglist-id___nl"
    }]
  }, {
    path: "/nl/ds/subscription",
    component: _d82197a8,
    name: "ds-subscription___nl"
  }, {
    path: "/nl/tica/connected",
    component: _279e6571,
    name: "tica-connected___nl"
  }, {
    path: "/pl/account/brands",
    component: _2144ff52,
    name: "account-brands___pl"
  }, {
    path: "/pl/account/channels",
    component: _4e40a5d9,
    name: "account-channels___pl"
  }, {
    path: "/pl/account/edit",
    component: _764547e0,
    name: "account-edit___pl"
  }, {
    path: "/pl/account/favorites",
    component: _6548ddc1,
    name: "account-favorites___pl"
  }, {
    path: "/pl/account/inbox",
    component: _806c4120,
    name: "account-inbox___pl",
    children: [{
      path: ":id?",
      component: _daa615ca,
      name: "account-inbox-id___pl"
    }]
  }, {
    path: "/pl/account/invoices",
    component: _7b285bec,
    name: "account-invoices___pl"
  }, {
    path: "/pl/account/orders",
    component: _c81a9ba4,
    name: "account-orders___pl"
  }, {
    path: "/pl/account/plus",
    component: _0ab0fbba,
    name: "account-plus___pl"
  }, {
    path: "/pl/account/tica",
    component: _4f7559ce,
    name: "account-tica___pl"
  }, {
    path: "/pl/account/trademart",
    component: _7e867024,
    name: "account-trademart___pl"
  }, {
    path: "/pl/ds/brands",
    component: _40d12dca,
    name: "ds-brands___pl"
  }, {
    path: "/pl/ds/import-list",
    component: _650d0aa6,
    name: "ds-import-list___pl"
  }, {
    path: "/pl/ds/inbox",
    component: _03dd2d2c,
    name: "ds-inbox___pl",
    children: [{
      path: ":id?",
      component: _246a1bd6,
      name: "ds-inbox-id___pl"
    }]
  }, {
    path: "/pl/ds/orders",
    component: _02b4daf4,
    name: "ds-orders___pl"
  }, {
    path: "/pl/ds/product-updates",
    component: _5495d153,
    name: "ds-product-updates___pl"
  }, {
    path: "/pl/ds/settings",
    component: _100241b2,
    name: "ds-settings___pl"
  }, {
    path: "/pl/ds/signup",
    component: _7e3df532,
    children: [{
      path: "",
      component: _a090baac,
      name: "ds-signup-index___pl"
    }, {
      path: "waitinglist",
      component: _5dfc1606,
      name: "ds-signup-index-waitinglist___pl"
    }, {
      path: "select/:id?",
      component: _055fd602,
      name: "ds-signup-index-select-id___pl"
    }, {
      path: "waitinglist/:id?",
      component: _00f83c24,
      name: "ds-signup-index-waitinglist-id___pl"
    }]
  }, {
    path: "/pl/ds/subscription",
    component: _d82197a8,
    name: "ds-subscription___pl"
  }, {
    path: "/pl/tica/connected",
    component: _279e6571,
    name: "tica-connected___pl"
  }, {
    path: "/account/plus/subscribe/return",
    component: _4d523c54,
    name: "account-plus-subscribe-return___en"
  }, {
    path: "/da/account/plus/subscribe",
    component: _4b98fc5e,
    name: "account-plus-subscribe___da"
  }, {
    path: "/da/ds/orders/new",
    component: _4b9adf42,
    name: "ds-orders-new___da"
  }, {
    path: "/da/ds/settings/account",
    component: _3af9cb8d,
    name: "ds-settings-account___da"
  }, {
    path: "/da/ds/settings/countries",
    component: _43c60e94,
    name: "ds-settings-countries___da"
  }, {
    path: "/da/ds/settings/mail",
    component: _605046f2,
    name: "ds-settings-mail___da"
  }, {
    path: "/da/ds/settings/preferences",
    component: _261bded8,
    name: "ds-settings-preferences___da"
  }, {
    path: "/da/ds/settings/software",
    component: _e993b712,
    name: "ds-settings-software___da"
  }, {
    path: "/da/ds/signup/error",
    component: _04a7239d,
    name: "ds-signup-error___da"
  }, {
    path: "/da/ds/subscription/paymentMethod",
    component: _092fcd3e,
    name: "ds-subscription-paymentMethod___da"
  }, {
    path: "/da/ds/subscription/return",
    component: _0fc2fe46,
    name: "ds-subscription-return___da"
  }, {
    path: "/da/ds/subscription/update-plan",
    component: _52c9d607,
    name: "ds-subscription-update-plan___da"
  }, {
    path: "/de/account/plus/subscribe",
    component: _4b98fc5e,
    name: "account-plus-subscribe___de"
  }, {
    path: "/de/ds/orders/new",
    component: _4b9adf42,
    name: "ds-orders-new___de"
  }, {
    path: "/de/ds/settings/account",
    component: _3af9cb8d,
    name: "ds-settings-account___de"
  }, {
    path: "/de/ds/settings/countries",
    component: _43c60e94,
    name: "ds-settings-countries___de"
  }, {
    path: "/de/ds/settings/mail",
    component: _605046f2,
    name: "ds-settings-mail___de"
  }, {
    path: "/de/ds/settings/preferences",
    component: _261bded8,
    name: "ds-settings-preferences___de"
  }, {
    path: "/de/ds/settings/software",
    component: _e993b712,
    name: "ds-settings-software___de"
  }, {
    path: "/de/ds/signup/error",
    component: _04a7239d,
    name: "ds-signup-error___de"
  }, {
    path: "/de/ds/subscription/paymentMethod",
    component: _092fcd3e,
    name: "ds-subscription-paymentMethod___de"
  }, {
    path: "/de/ds/subscription/return",
    component: _0fc2fe46,
    name: "ds-subscription-return___de"
  }, {
    path: "/de/ds/subscription/update-plan",
    component: _52c9d607,
    name: "ds-subscription-update-plan___de"
  }, {
    path: "/es/account/plus/subscribe",
    component: _4b98fc5e,
    name: "account-plus-subscribe___es"
  }, {
    path: "/es/ds/orders/new",
    component: _4b9adf42,
    name: "ds-orders-new___es"
  }, {
    path: "/es/ds/settings/account",
    component: _3af9cb8d,
    name: "ds-settings-account___es"
  }, {
    path: "/es/ds/settings/countries",
    component: _43c60e94,
    name: "ds-settings-countries___es"
  }, {
    path: "/es/ds/settings/mail",
    component: _605046f2,
    name: "ds-settings-mail___es"
  }, {
    path: "/es/ds/settings/preferences",
    component: _261bded8,
    name: "ds-settings-preferences___es"
  }, {
    path: "/es/ds/settings/software",
    component: _e993b712,
    name: "ds-settings-software___es"
  }, {
    path: "/es/ds/signup/error",
    component: _04a7239d,
    name: "ds-signup-error___es"
  }, {
    path: "/es/ds/subscription/paymentMethod",
    component: _092fcd3e,
    name: "ds-subscription-paymentMethod___es"
  }, {
    path: "/es/ds/subscription/return",
    component: _0fc2fe46,
    name: "ds-subscription-return___es"
  }, {
    path: "/es/ds/subscription/update-plan",
    component: _52c9d607,
    name: "ds-subscription-update-plan___es"
  }, {
    path: "/fr/account/plus/subscribe",
    component: _4b98fc5e,
    name: "account-plus-subscribe___fr"
  }, {
    path: "/fr/ds/orders/new",
    component: _4b9adf42,
    name: "ds-orders-new___fr"
  }, {
    path: "/fr/ds/settings/account",
    component: _3af9cb8d,
    name: "ds-settings-account___fr"
  }, {
    path: "/fr/ds/settings/countries",
    component: _43c60e94,
    name: "ds-settings-countries___fr"
  }, {
    path: "/fr/ds/settings/mail",
    component: _605046f2,
    name: "ds-settings-mail___fr"
  }, {
    path: "/fr/ds/settings/preferences",
    component: _261bded8,
    name: "ds-settings-preferences___fr"
  }, {
    path: "/fr/ds/settings/software",
    component: _e993b712,
    name: "ds-settings-software___fr"
  }, {
    path: "/fr/ds/signup/error",
    component: _04a7239d,
    name: "ds-signup-error___fr"
  }, {
    path: "/fr/ds/subscription/paymentMethod",
    component: _092fcd3e,
    name: "ds-subscription-paymentMethod___fr"
  }, {
    path: "/fr/ds/subscription/return",
    component: _0fc2fe46,
    name: "ds-subscription-return___fr"
  }, {
    path: "/fr/ds/subscription/update-plan",
    component: _52c9d607,
    name: "ds-subscription-update-plan___fr"
  }, {
    path: "/it/account/plus/subscribe",
    component: _4b98fc5e,
    name: "account-plus-subscribe___it"
  }, {
    path: "/it/ds/orders/new",
    component: _4b9adf42,
    name: "ds-orders-new___it"
  }, {
    path: "/it/ds/settings/account",
    component: _3af9cb8d,
    name: "ds-settings-account___it"
  }, {
    path: "/it/ds/settings/countries",
    component: _43c60e94,
    name: "ds-settings-countries___it"
  }, {
    path: "/it/ds/settings/mail",
    component: _605046f2,
    name: "ds-settings-mail___it"
  }, {
    path: "/it/ds/settings/preferences",
    component: _261bded8,
    name: "ds-settings-preferences___it"
  }, {
    path: "/it/ds/settings/software",
    component: _e993b712,
    name: "ds-settings-software___it"
  }, {
    path: "/it/ds/signup/error",
    component: _04a7239d,
    name: "ds-signup-error___it"
  }, {
    path: "/it/ds/subscription/paymentMethod",
    component: _092fcd3e,
    name: "ds-subscription-paymentMethod___it"
  }, {
    path: "/it/ds/subscription/return",
    component: _0fc2fe46,
    name: "ds-subscription-return___it"
  }, {
    path: "/it/ds/subscription/update-plan",
    component: _52c9d607,
    name: "ds-subscription-update-plan___it"
  }, {
    path: "/nl/account/plus/subscribe",
    component: _4b98fc5e,
    name: "account-plus-subscribe___nl"
  }, {
    path: "/nl/ds/orders/new",
    component: _4b9adf42,
    name: "ds-orders-new___nl"
  }, {
    path: "/nl/ds/settings/account",
    component: _3af9cb8d,
    name: "ds-settings-account___nl"
  }, {
    path: "/nl/ds/settings/countries",
    component: _43c60e94,
    name: "ds-settings-countries___nl"
  }, {
    path: "/nl/ds/settings/mail",
    component: _605046f2,
    name: "ds-settings-mail___nl"
  }, {
    path: "/nl/ds/settings/preferences",
    component: _261bded8,
    name: "ds-settings-preferences___nl"
  }, {
    path: "/nl/ds/settings/software",
    component: _e993b712,
    name: "ds-settings-software___nl"
  }, {
    path: "/nl/ds/signup/error",
    component: _04a7239d,
    name: "ds-signup-error___nl"
  }, {
    path: "/nl/ds/subscription/paymentMethod",
    component: _092fcd3e,
    name: "ds-subscription-paymentMethod___nl"
  }, {
    path: "/nl/ds/subscription/return",
    component: _0fc2fe46,
    name: "ds-subscription-return___nl"
  }, {
    path: "/nl/ds/subscription/update-plan",
    component: _52c9d607,
    name: "ds-subscription-update-plan___nl"
  }, {
    path: "/pl/account/plus/subscribe",
    component: _4b98fc5e,
    name: "account-plus-subscribe___pl"
  }, {
    path: "/pl/ds/orders/new",
    component: _4b9adf42,
    name: "ds-orders-new___pl"
  }, {
    path: "/pl/ds/settings/account",
    component: _3af9cb8d,
    name: "ds-settings-account___pl"
  }, {
    path: "/pl/ds/settings/countries",
    component: _43c60e94,
    name: "ds-settings-countries___pl"
  }, {
    path: "/pl/ds/settings/mail",
    component: _605046f2,
    name: "ds-settings-mail___pl"
  }, {
    path: "/pl/ds/settings/preferences",
    component: _261bded8,
    name: "ds-settings-preferences___pl"
  }, {
    path: "/pl/ds/settings/software",
    component: _e993b712,
    name: "ds-settings-software___pl"
  }, {
    path: "/pl/ds/signup/error",
    component: _04a7239d,
    name: "ds-signup-error___pl"
  }, {
    path: "/pl/ds/subscription/paymentMethod",
    component: _092fcd3e,
    name: "ds-subscription-paymentMethod___pl"
  }, {
    path: "/pl/ds/subscription/return",
    component: _0fc2fe46,
    name: "ds-subscription-return___pl"
  }, {
    path: "/pl/ds/subscription/update-plan",
    component: _52c9d607,
    name: "ds-subscription-update-plan___pl"
  }, {
    path: "/da/account/plus/subscribe/return",
    component: _4d523c54,
    name: "account-plus-subscribe-return___da"
  }, {
    path: "/de/account/plus/subscribe/return",
    component: _4d523c54,
    name: "account-plus-subscribe-return___de"
  }, {
    path: "/es/account/plus/subscribe/return",
    component: _4d523c54,
    name: "account-plus-subscribe-return___es"
  }, {
    path: "/fr/account/plus/subscribe/return",
    component: _4d523c54,
    name: "account-plus-subscribe-return___fr"
  }, {
    path: "/it/account/plus/subscribe/return",
    component: _4d523c54,
    name: "account-plus-subscribe-return___it"
  }, {
    path: "/nl/account/plus/subscribe/return",
    component: _4d523c54,
    name: "account-plus-subscribe-return___nl"
  }, {
    path: "/pl/account/plus/subscribe/return",
    component: _4d523c54,
    name: "account-plus-subscribe-return___pl"
  }, {
    path: "/",
    component: _4cde02c3,
    name: "home___en"
  }, {
    path: "/da/account/channels/:id",
    component: _6d404a81,
    name: "account-channels-id___da"
  }, {
    path: "/da/account/orders/:id",
    component: _cea9f3ce,
    name: "account-orders-id___da"
  }, {
    path: "/da/ds/orders/:id",
    component: _37e50a5c,
    name: "ds-orders-id___da"
  }, {
    path: "/da/ds/product-updates/:id?",
    component: _2bfe0c7b,
    name: "ds-product-updates-id___da"
  }, {
    path: "/da/order/direct/:token?",
    component: _3ce548aa,
    name: "order-direct-token___da"
  }, {
    path: "/da/tica/invites/:token",
    component: _4d418a2a,
    name: "tica-invites-token___da"
  }, {
    path: "/da/trademart/invites/:token",
    component: _3d3c967b,
    name: "trademart-invites-token___da"
  }, {
    path: "/de/account/channels/:id",
    component: _6d404a81,
    name: "account-channels-id___de"
  }, {
    path: "/de/account/orders/:id",
    component: _cea9f3ce,
    name: "account-orders-id___de"
  }, {
    path: "/de/ds/orders/:id",
    component: _37e50a5c,
    name: "ds-orders-id___de"
  }, {
    path: "/de/ds/product-updates/:id?",
    component: _2bfe0c7b,
    name: "ds-product-updates-id___de"
  }, {
    path: "/de/order/direct/:token?",
    component: _3ce548aa,
    name: "order-direct-token___de"
  }, {
    path: "/de/tica/invites/:token",
    component: _4d418a2a,
    name: "tica-invites-token___de"
  }, {
    path: "/de/trademart/invites/:token",
    component: _3d3c967b,
    name: "trademart-invites-token___de"
  }, {
    path: "/es/account/channels/:id",
    component: _6d404a81,
    name: "account-channels-id___es"
  }, {
    path: "/es/account/orders/:id",
    component: _cea9f3ce,
    name: "account-orders-id___es"
  }, {
    path: "/es/ds/orders/:id",
    component: _37e50a5c,
    name: "ds-orders-id___es"
  }, {
    path: "/es/ds/product-updates/:id?",
    component: _2bfe0c7b,
    name: "ds-product-updates-id___es"
  }, {
    path: "/es/order/direct/:token?",
    component: _3ce548aa,
    name: "order-direct-token___es"
  }, {
    path: "/es/tica/invites/:token",
    component: _4d418a2a,
    name: "tica-invites-token___es"
  }, {
    path: "/es/trademart/invites/:token",
    component: _3d3c967b,
    name: "trademart-invites-token___es"
  }, {
    path: "/fr/account/channels/:id",
    component: _6d404a81,
    name: "account-channels-id___fr"
  }, {
    path: "/fr/account/orders/:id",
    component: _cea9f3ce,
    name: "account-orders-id___fr"
  }, {
    path: "/fr/ds/orders/:id",
    component: _37e50a5c,
    name: "ds-orders-id___fr"
  }, {
    path: "/fr/ds/product-updates/:id?",
    component: _2bfe0c7b,
    name: "ds-product-updates-id___fr"
  }, {
    path: "/fr/order/direct/:token?",
    component: _3ce548aa,
    name: "order-direct-token___fr"
  }, {
    path: "/fr/tica/invites/:token",
    component: _4d418a2a,
    name: "tica-invites-token___fr"
  }, {
    path: "/fr/trademart/invites/:token",
    component: _3d3c967b,
    name: "trademart-invites-token___fr"
  }, {
    path: "/it/account/channels/:id",
    component: _6d404a81,
    name: "account-channels-id___it"
  }, {
    path: "/it/account/orders/:id",
    component: _cea9f3ce,
    name: "account-orders-id___it"
  }, {
    path: "/it/ds/orders/:id",
    component: _37e50a5c,
    name: "ds-orders-id___it"
  }, {
    path: "/it/ds/product-updates/:id?",
    component: _2bfe0c7b,
    name: "ds-product-updates-id___it"
  }, {
    path: "/it/order/direct/:token?",
    component: _3ce548aa,
    name: "order-direct-token___it"
  }, {
    path: "/it/tica/invites/:token",
    component: _4d418a2a,
    name: "tica-invites-token___it"
  }, {
    path: "/it/trademart/invites/:token",
    component: _3d3c967b,
    name: "trademart-invites-token___it"
  }, {
    path: "/nl/account/channels/:id",
    component: _6d404a81,
    name: "account-channels-id___nl"
  }, {
    path: "/nl/account/orders/:id",
    component: _cea9f3ce,
    name: "account-orders-id___nl"
  }, {
    path: "/nl/ds/orders/:id",
    component: _37e50a5c,
    name: "ds-orders-id___nl"
  }, {
    path: "/nl/ds/product-updates/:id?",
    component: _2bfe0c7b,
    name: "ds-product-updates-id___nl"
  }, {
    path: "/nl/order/direct/:token?",
    component: _3ce548aa,
    name: "order-direct-token___nl"
  }, {
    path: "/nl/tica/invites/:token",
    component: _4d418a2a,
    name: "tica-invites-token___nl"
  }, {
    path: "/nl/trademart/invites/:token",
    component: _3d3c967b,
    name: "trademart-invites-token___nl"
  }, {
    path: "/pl/account/channels/:id",
    component: _6d404a81,
    name: "account-channels-id___pl"
  }, {
    path: "/pl/account/orders/:id",
    component: _cea9f3ce,
    name: "account-orders-id___pl"
  }, {
    path: "/pl/ds/orders/:id",
    component: _37e50a5c,
    name: "ds-orders-id___pl"
  }, {
    path: "/pl/ds/product-updates/:id?",
    component: _2bfe0c7b,
    name: "ds-product-updates-id___pl"
  }, {
    path: "/pl/order/direct/:token?",
    component: _3ce548aa,
    name: "order-direct-token___pl"
  }, {
    path: "/pl/tica/invites/:token",
    component: _4d418a2a,
    name: "tica-invites-token___pl"
  }, {
    path: "/pl/trademart/invites/:token",
    component: _3d3c967b,
    name: "trademart-invites-token___pl"
  }, {
    path: "/da/account/orders/:id/updates",
    component: _ec80cfd8,
    name: "account-orders-id-updates___da"
  }, {
    path: "/da/ds/orders/:token/payment",
    component: _1c7786bf,
    name: "ds-orders-token-payment___da"
  }, {
    path: "/da/ds/store/:slug?/about",
    component: _217cd37e,
    name: "ds-store-slug-about___da"
  }, {
    path: "/de/account/orders/:id/updates",
    component: _ec80cfd8,
    name: "account-orders-id-updates___de"
  }, {
    path: "/de/ds/orders/:token/payment",
    component: _1c7786bf,
    name: "ds-orders-token-payment___de"
  }, {
    path: "/de/ds/store/:slug?/about",
    component: _217cd37e,
    name: "ds-store-slug-about___de"
  }, {
    path: "/es/account/orders/:id/updates",
    component: _ec80cfd8,
    name: "account-orders-id-updates___es"
  }, {
    path: "/es/ds/orders/:token/payment",
    component: _1c7786bf,
    name: "ds-orders-token-payment___es"
  }, {
    path: "/es/ds/store/:slug?/about",
    component: _217cd37e,
    name: "ds-store-slug-about___es"
  }, {
    path: "/fr/account/orders/:id/updates",
    component: _ec80cfd8,
    name: "account-orders-id-updates___fr"
  }, {
    path: "/fr/ds/orders/:token/payment",
    component: _1c7786bf,
    name: "ds-orders-token-payment___fr"
  }, {
    path: "/fr/ds/store/:slug?/about",
    component: _217cd37e,
    name: "ds-store-slug-about___fr"
  }, {
    path: "/it/account/orders/:id/updates",
    component: _ec80cfd8,
    name: "account-orders-id-updates___it"
  }, {
    path: "/it/ds/orders/:token/payment",
    component: _1c7786bf,
    name: "ds-orders-token-payment___it"
  }, {
    path: "/it/ds/store/:slug?/about",
    component: _217cd37e,
    name: "ds-store-slug-about___it"
  }, {
    path: "/nl/account/orders/:id/updates",
    component: _ec80cfd8,
    name: "account-orders-id-updates___nl"
  }, {
    path: "/nl/ds/orders/:token/payment",
    component: _1c7786bf,
    name: "ds-orders-token-payment___nl"
  }, {
    path: "/nl/ds/store/:slug?/about",
    component: _217cd37e,
    name: "ds-store-slug-about___nl"
  }, {
    path: "/pl/account/orders/:id/updates",
    component: _ec80cfd8,
    name: "account-orders-id-updates___pl"
  }, {
    path: "/pl/ds/orders/:token/payment",
    component: _1c7786bf,
    name: "ds-orders-token-payment___pl"
  }, {
    path: "/pl/ds/store/:slug?/about",
    component: _217cd37e,
    name: "ds-store-slug-about___pl"
  }, {
    path: "/da/ds/orders/:token/return/:paymentId?",
    component: _043bac7a,
    name: "ds-orders-token-return-paymentId___da"
  }, {
    path: "/da/ds/store/:slug?/listings/:listingId?",
    component: _5a72fb91,
    name: "ds-store-slug-listings-listingId___da"
  }, {
    path: "/de/ds/orders/:token/return/:paymentId?",
    component: _043bac7a,
    name: "ds-orders-token-return-paymentId___de"
  }, {
    path: "/de/ds/store/:slug?/listings/:listingId?",
    component: _5a72fb91,
    name: "ds-store-slug-listings-listingId___de"
  }, {
    path: "/es/ds/orders/:token/return/:paymentId?",
    component: _043bac7a,
    name: "ds-orders-token-return-paymentId___es"
  }, {
    path: "/es/ds/store/:slug?/listings/:listingId?",
    component: _5a72fb91,
    name: "ds-store-slug-listings-listingId___es"
  }, {
    path: "/fr/ds/orders/:token/return/:paymentId?",
    component: _043bac7a,
    name: "ds-orders-token-return-paymentId___fr"
  }, {
    path: "/fr/ds/store/:slug?/listings/:listingId?",
    component: _5a72fb91,
    name: "ds-store-slug-listings-listingId___fr"
  }, {
    path: "/it/ds/orders/:token/return/:paymentId?",
    component: _043bac7a,
    name: "ds-orders-token-return-paymentId___it"
  }, {
    path: "/it/ds/store/:slug?/listings/:listingId?",
    component: _5a72fb91,
    name: "ds-store-slug-listings-listingId___it"
  }, {
    path: "/nl/ds/orders/:token/return/:paymentId?",
    component: _043bac7a,
    name: "ds-orders-token-return-paymentId___nl"
  }, {
    path: "/nl/ds/store/:slug?/listings/:listingId?",
    component: _5a72fb91,
    name: "ds-store-slug-listings-listingId___nl"
  }, {
    path: "/pl/ds/orders/:token/return/:paymentId?",
    component: _043bac7a,
    name: "ds-orders-token-return-paymentId___pl"
  }, {
    path: "/pl/ds/store/:slug?/listings/:listingId?",
    component: _5a72fb91,
    name: "ds-store-slug-listings-listingId___pl"
  }, {
    path: "/es/ds/marketplace/:categoryPath*",
    component: _15ca84a2,
    props: {"isMarketplacePage":true,"type":"storefronts","mode":"dropshipping"},
    name: "ds-marketplace___es"
  }, {
    path: "/it/ds/marketplace/:categoryPath*",
    component: _15ca84a2,
    props: {"isMarketplacePage":true,"type":"storefronts","mode":"dropshipping"},
    name: "ds-marketplace___it"
  }, {
    path: "/da/ds/marketplace/:categoryPath*",
    component: _15ca84a2,
    props: {"isMarketplacePage":true,"type":"storefronts","mode":"dropshipping"},
    name: "ds-marketplace___da"
  }, {
    path: "/pl/ds/marketplace/:categoryPath*",
    component: _15ca84a2,
    props: {"isMarketplacePage":true,"type":"storefronts","mode":"dropshipping"},
    name: "ds-marketplace___pl"
  }, {
    path: "/fr/ds/marketplace/:categoryPath*",
    component: _15ca84a2,
    props: {"isMarketplacePage":true,"type":"storefronts","mode":"dropshipping"},
    name: "ds-marketplace___fr"
  }, {
    path: "/de/ds/marketplace/:categoryPath*",
    component: _15ca84a2,
    props: {"isMarketplacePage":true,"type":"storefronts","mode":"dropshipping"},
    name: "ds-marketplace___de"
  }, {
    path: "/nl/ds/marketplace/:categoryPath*",
    component: _15ca84a2,
    props: {"isMarketplacePage":true,"type":"storefronts","mode":"dropshipping"},
    name: "ds-marketplace___nl"
  }, {
    path: "/es/ds/search/:categoryPath*",
    component: _15ca84a2,
    props: {"isSearchPage":true,"type":"listings","mode":"dropshipping"},
    name: "ds-search___es"
  }, {
    path: "/it/ds/search/:categoryPath*",
    component: _15ca84a2,
    props: {"isSearchPage":true,"type":"listings","mode":"dropshipping"},
    name: "ds-search___it"
  }, {
    path: "/da/ds/search/:categoryPath*",
    component: _15ca84a2,
    props: {"isSearchPage":true,"type":"listings","mode":"dropshipping"},
    name: "ds-search___da"
  }, {
    path: "/pl/ds/search/:categoryPath*",
    component: _15ca84a2,
    props: {"isSearchPage":true,"type":"listings","mode":"dropshipping"},
    name: "ds-search___pl"
  }, {
    path: "/fr/ds/search/:categoryPath*",
    component: _15ca84a2,
    props: {"isSearchPage":true,"type":"listings","mode":"dropshipping"},
    name: "ds-search___fr"
  }, {
    path: "/de/ds/search/:categoryPath*",
    component: _15ca84a2,
    props: {"isSearchPage":true,"type":"listings","mode":"dropshipping"},
    name: "ds-search___de"
  }, {
    path: "/nl/ds/search/:categoryPath*",
    component: _15ca84a2,
    props: {"isSearchPage":true,"type":"listings","mode":"dropshipping"},
    name: "ds-search___nl"
  }, {
    path: "/da/ds/store/:slug/collection/:collectionSlug",
    component: _4134ae43,
    name: "ds-store-slug-collection___da"
  }, {
    path: "/da/tica/invites/:token?/connect/:id?",
    component: _30cd7aed,
    name: "tica-invites-token-connect-id___da"
  }, {
    path: "/da/trademart/invites/:token?/connect/:id?",
    component: _ffaf7304,
    name: "trademart-invites-token-connect-id___da"
  }, {
    path: "/de/ds/store/:slug/collection/:collectionSlug",
    component: _4134ae43,
    name: "ds-store-slug-collection___de"
  }, {
    path: "/de/tica/invites/:token?/connect/:id?",
    component: _30cd7aed,
    name: "tica-invites-token-connect-id___de"
  }, {
    path: "/de/trademart/invites/:token?/connect/:id?",
    component: _ffaf7304,
    name: "trademart-invites-token-connect-id___de"
  }, {
    path: "/es/ds/store/:slug/collection/:collectionSlug",
    component: _4134ae43,
    name: "ds-store-slug-collection___es"
  }, {
    path: "/es/tica/invites/:token?/connect/:id?",
    component: _30cd7aed,
    name: "tica-invites-token-connect-id___es"
  }, {
    path: "/es/trademart/invites/:token?/connect/:id?",
    component: _ffaf7304,
    name: "trademart-invites-token-connect-id___es"
  }, {
    path: "/fr/ds/store/:slug/collection/:collectionSlug",
    component: _4134ae43,
    name: "ds-store-slug-collection___fr"
  }, {
    path: "/fr/tica/invites/:token?/connect/:id?",
    component: _30cd7aed,
    name: "tica-invites-token-connect-id___fr"
  }, {
    path: "/fr/trademart/invites/:token?/connect/:id?",
    component: _ffaf7304,
    name: "trademart-invites-token-connect-id___fr"
  }, {
    path: "/it/ds/store/:slug/collection/:collectionSlug",
    component: _4134ae43,
    name: "ds-store-slug-collection___it"
  }, {
    path: "/it/tica/invites/:token?/connect/:id?",
    component: _30cd7aed,
    name: "tica-invites-token-connect-id___it"
  }, {
    path: "/it/trademart/invites/:token?/connect/:id?",
    component: _ffaf7304,
    name: "trademart-invites-token-connect-id___it"
  }, {
    path: "/nl/ds/store/:slug/collection/:collectionSlug",
    component: _4134ae43,
    name: "ds-store-slug-collection___nl"
  }, {
    path: "/nl/tica/invites/:token?/connect/:id?",
    component: _30cd7aed,
    name: "tica-invites-token-connect-id___nl"
  }, {
    path: "/nl/trademart/invites/:token?/connect/:id?",
    component: _ffaf7304,
    name: "trademart-invites-token-connect-id___nl"
  }, {
    path: "/pl/ds/store/:slug/collection/:collectionSlug",
    component: _4134ae43,
    name: "ds-store-slug-collection___pl"
  }, {
    path: "/pl/tica/invites/:token?/connect/:id?",
    component: _30cd7aed,
    name: "tica-invites-token-connect-id___pl"
  }, {
    path: "/pl/trademart/invites/:token?/connect/:id?",
    component: _ffaf7304,
    name: "trademart-invites-token-connect-id___pl"
  }, {
    path: "/es/ds/store/:slug/:categoryPath*",
    component: _4134ae43,
    name: "ds-store-slug___es"
  }, {
    path: "/it/ds/store/:slug/:categoryPath*",
    component: _4134ae43,
    name: "ds-store-slug___it"
  }, {
    path: "/da/ds/store/:slug/:categoryPath*",
    component: _4134ae43,
    name: "ds-store-slug___da"
  }, {
    path: "/pl/ds/store/:slug/:categoryPath*",
    component: _4134ae43,
    name: "ds-store-slug___pl"
  }, {
    path: "/fr/ds/store/:slug/:categoryPath*",
    component: _4134ae43,
    name: "ds-store-slug___fr"
  }, {
    path: "/de/ds/store/:slug/:categoryPath*",
    component: _4134ae43,
    name: "ds-store-slug___de"
  }, {
    path: "/nl/ds/store/:slug/:categoryPath*",
    component: _4134ae43,
    name: "ds-store-slug___nl"
  }, {
    path: "/es/ds/listings/:categoryPath*",
    component: _15ca84a2,
    props: {"isListingsPage":true,"type":"listings","mode":"dropshipping"},
    name: "ds-listings___es"
  }, {
    path: "/it/ds/listings/:categoryPath*",
    component: _15ca84a2,
    props: {"isListingsPage":true,"type":"listings","mode":"dropshipping"},
    name: "ds-listings___it"
  }, {
    path: "/da/ds/listings/:categoryPath*",
    component: _15ca84a2,
    props: {"isListingsPage":true,"type":"listings","mode":"dropshipping"},
    name: "ds-listings___da"
  }, {
    path: "/pl/ds/listings/:categoryPath*",
    component: _15ca84a2,
    props: {"isListingsPage":true,"type":"listings","mode":"dropshipping"},
    name: "ds-listings___pl"
  }, {
    path: "/fr/ds/listings/:categoryPath*",
    component: _15ca84a2,
    props: {"isListingsPage":true,"type":"listings","mode":"dropshipping"},
    name: "ds-listings___fr"
  }, {
    path: "/de/ds/listings/:categoryPath*",
    component: _15ca84a2,
    props: {"isListingsPage":true,"type":"listings","mode":"dropshipping"},
    name: "ds-listings___de"
  }, {
    path: "/nl/ds/listings/:categoryPath*",
    component: _15ca84a2,
    props: {"isListingsPage":true,"type":"listings","mode":"dropshipping"},
    name: "ds-listings___nl"
  }, {
    path: "/account/channels/:id",
    component: _6d404a81,
    name: "account-channels-id___en"
  }, {
    path: "/account/orders/:id",
    component: _cea9f3ce,
    name: "account-orders-id___en"
  }, {
    path: "/da/brands/:type",
    component: _0af3b87a,
    name: "brands-type___da"
  }, {
    path: "/da/email-settings/:token?",
    component: _73fad1fe,
    name: "email-settings-token___da"
  }, {
    path: "/da/order/:token?",
    component: _cb1f3282,
    name: "order-token___da",
    children: [{
      path: "confirmation",
      component: _5dfe61b5,
      name: "order-token-confirmation___da"
    }, {
      path: "payment",
      component: _18e32994,
      name: "order-token-payment___da"
    }, {
      path: "return/:id?",
      component: _59c880db,
      name: "order-token-return-id___da"
    }]
  }, {
    path: "/da/page/:slug?",
    component: _a438c924,
    name: "page-slug___da"
  }, {
    path: "/da/pay/:slug?",
    component: _a3457da2,
    name: "pay-slug___da"
  }, {
    path: "/da/retailers/:type",
    component: _456d834e,
    name: "retailers-type___da"
  }, {
    path: "/de/brands/:type",
    component: _0af3b87a,
    name: "brands-type___de"
  }, {
    path: "/de/email-settings/:token?",
    component: _73fad1fe,
    name: "email-settings-token___de"
  }, {
    path: "/de/order/:token?",
    component: _cb1f3282,
    name: "order-token___de",
    children: [{
      path: "confirmation",
      component: _5dfe61b5,
      name: "order-token-confirmation___de"
    }, {
      path: "payment",
      component: _18e32994,
      name: "order-token-payment___de"
    }, {
      path: "return/:id?",
      component: _59c880db,
      name: "order-token-return-id___de"
    }]
  }, {
    path: "/de/page/:slug?",
    component: _a438c924,
    name: "page-slug___de"
  }, {
    path: "/de/pay/:slug?",
    component: _a3457da2,
    name: "pay-slug___de"
  }, {
    path: "/de/retailers/:type",
    component: _456d834e,
    name: "retailers-type___de"
  }, {
    path: "/ds/orders/:id",
    component: _37e50a5c,
    name: "ds-orders-id___en"
  }, {
    path: "/ds/product-updates/:id?",
    component: _2bfe0c7b,
    name: "ds-product-updates-id___en"
  }, {
    path: "/es/brands/:type",
    component: _0af3b87a,
    name: "brands-type___es"
  }, {
    path: "/es/email-settings/:token?",
    component: _73fad1fe,
    name: "email-settings-token___es"
  }, {
    path: "/es/order/:token?",
    component: _cb1f3282,
    name: "order-token___es",
    children: [{
      path: "confirmation",
      component: _5dfe61b5,
      name: "order-token-confirmation___es"
    }, {
      path: "payment",
      component: _18e32994,
      name: "order-token-payment___es"
    }, {
      path: "return/:id?",
      component: _59c880db,
      name: "order-token-return-id___es"
    }]
  }, {
    path: "/es/page/:slug?",
    component: _a438c924,
    name: "page-slug___es"
  }, {
    path: "/es/pay/:slug?",
    component: _a3457da2,
    name: "pay-slug___es"
  }, {
    path: "/es/retailers/:type",
    component: _456d834e,
    name: "retailers-type___es"
  }, {
    path: "/fr/email-settings/:token?",
    component: _73fad1fe,
    name: "email-settings-token___fr"
  }, {
    path: "/fr/order/:token?",
    component: _cb1f3282,
    name: "order-token___fr",
    children: [{
      path: "confirmation",
      component: _5dfe61b5,
      name: "order-token-confirmation___fr"
    }, {
      path: "payment",
      component: _18e32994,
      name: "order-token-payment___fr"
    }, {
      path: "return/:id?",
      component: _59c880db,
      name: "order-token-return-id___fr"
    }]
  }, {
    path: "/fr/page/:slug?",
    component: _a438c924,
    name: "page-slug___fr"
  }, {
    path: "/fr/pay/:slug?",
    component: _a3457da2,
    name: "pay-slug___fr"
  }, {
    path: "/fr/retailers/:type",
    component: _456d834e,
    name: "retailers-type___fr"
  }, {
    path: "/it/brands/:type",
    component: _0af3b87a,
    name: "brands-type___it"
  }, {
    path: "/it/email-settings/:token?",
    component: _73fad1fe,
    name: "email-settings-token___it"
  }, {
    path: "/it/order/:token?",
    component: _cb1f3282,
    name: "order-token___it",
    children: [{
      path: "confirmation",
      component: _5dfe61b5,
      name: "order-token-confirmation___it"
    }, {
      path: "payment",
      component: _18e32994,
      name: "order-token-payment___it"
    }, {
      path: "return/:id?",
      component: _59c880db,
      name: "order-token-return-id___it"
    }]
  }, {
    path: "/it/page/:slug?",
    component: _a438c924,
    name: "page-slug___it"
  }, {
    path: "/it/pay/:slug?",
    component: _a3457da2,
    name: "pay-slug___it"
  }, {
    path: "/it/retailers/:type",
    component: _456d834e,
    name: "retailers-type___it"
  }, {
    path: "/nl/email-settings/:token?",
    component: _73fad1fe,
    name: "email-settings-token___nl"
  }, {
    path: "/nl/order/:token?",
    component: _cb1f3282,
    name: "order-token___nl",
    children: [{
      path: "confirmation",
      component: _5dfe61b5,
      name: "order-token-confirmation___nl"
    }, {
      path: "payment",
      component: _18e32994,
      name: "order-token-payment___nl"
    }, {
      path: "return/:id?",
      component: _59c880db,
      name: "order-token-return-id___nl"
    }]
  }, {
    path: "/nl/page/:slug?",
    component: _a438c924,
    name: "page-slug___nl"
  }, {
    path: "/nl/pay/:slug?",
    component: _a3457da2,
    name: "pay-slug___nl"
  }, {
    path: "/nl/retailers/:type",
    component: _456d834e,
    name: "retailers-type___nl"
  }, {
    path: "/order/direct/:token?",
    component: _3ce548aa,
    name: "order-direct-token___en"
  }, {
    path: "/pl/brands/:type",
    component: _0af3b87a,
    name: "brands-type___pl"
  }, {
    path: "/pl/page/:slug?",
    component: _a438c924,
    name: "page-slug___pl"
  }, {
    path: "/pl/pay/:slug?",
    component: _a3457da2,
    name: "pay-slug___pl"
  }, {
    path: "/pl/retailers/:type",
    component: _456d834e,
    name: "retailers-type___pl"
  }, {
    path: "/tica/invites/:token",
    component: _4d418a2a,
    name: "tica-invites-token___en"
  }, {
    path: "/trademart/invites/:token",
    component: _3d3c967b,
    name: "trademart-invites-token___en"
  }, {
    path: "/account/orders/:id/updates",
    component: _ec80cfd8,
    name: "account-orders-id-updates___en"
  }, {
    path: "/da/store/:slug?/about",
    component: _763b26e6,
    name: "store-slug-about___da"
  }, {
    path: "/da/store/:slug?/signup",
    component: _3fd83ee2,
    name: "store-slug-signup___da"
  }, {
    path: "/de/store/:slug?/about",
    component: _763b26e6,
    name: "store-slug-about___de"
  }, {
    path: "/de/store/:slug?/signup",
    component: _3fd83ee2,
    name: "store-slug-signup___de"
  }, {
    path: "/ds/orders/:token/payment",
    component: _1c7786bf,
    name: "ds-orders-token-payment___en"
  }, {
    path: "/ds/store/:slug?/about",
    component: _217cd37e,
    name: "ds-store-slug-about___en"
  }, {
    path: "/es/store/:slug?/about",
    component: _763b26e6,
    name: "store-slug-about___es"
  }, {
    path: "/es/store/:slug?/signup",
    component: _3fd83ee2,
    name: "store-slug-signup___es"
  }, {
    path: "/fr/store/:slug?/about",
    component: _763b26e6,
    name: "store-slug-about___fr"
  }, {
    path: "/fr/store/:slug?/signup",
    component: _3fd83ee2,
    name: "store-slug-signup___fr"
  }, {
    path: "/it/store/:slug?/about",
    component: _763b26e6,
    name: "store-slug-about___it"
  }, {
    path: "/it/store/:slug?/signup",
    component: _3fd83ee2,
    name: "store-slug-signup___it"
  }, {
    path: "/nl/store/:slug?/about",
    component: _763b26e6,
    name: "store-slug-about___nl"
  }, {
    path: "/nl/store/:slug?/signup",
    component: _3fd83ee2,
    name: "store-slug-signup___nl"
  }, {
    path: "/pl/store/:slug?/about",
    component: _763b26e6,
    name: "store-slug-about___pl"
  }, {
    path: "/pl/store/:slug?/signup",
    component: _3fd83ee2,
    name: "store-slug-signup___pl"
  }, {
    path: "/ds/orders/:token/return/:paymentId?",
    component: _043bac7a,
    name: "ds-orders-token-return-paymentId___en"
  }, {
    path: "/ds/store/:slug?/listings/:listingId?",
    component: _5a72fb91,
    name: "ds-store-slug-listings-listingId___en"
  }, {
    path: "/ds/marketplace/:categoryPath*",
    component: _15ca84a2,
    props: {"isMarketplacePage":true,"type":"storefronts","mode":"dropshipping"},
    name: "ds-marketplace___en"
  }, {
    path: "/ds/search/:categoryPath*",
    component: _15ca84a2,
    props: {"isSearchPage":true,"type":"listings","mode":"dropshipping"},
    name: "ds-search___en"
  }, {
    path: "/ds/store/:slug/collection/:collectionSlug",
    component: _4134ae43,
    name: "ds-store-slug-collection___en"
  }, {
    path: "/tica/invites/:token?/connect/:id?",
    component: _30cd7aed,
    name: "tica-invites-token-connect-id___en"
  }, {
    path: "/ds/store/:slug/:categoryPath*",
    component: _4134ae43,
    name: "ds-store-slug___en"
  }, {
    path: "/ds/listings/:categoryPath*",
    component: _15ca84a2,
    props: {"isListingsPage":true,"type":"listings","mode":"dropshipping"},
    name: "ds-listings___en"
  }, {
    path: "/fr/brands/:type",
    component: _0af3b87a,
    name: "brands-type___fr"
  }, {
    path: "/nl/brands/:type",
    component: _0af3b87a,
    name: "brands-type___nl"
  }, {
    path: "/pl/email-settings/:token?",
    component: _73fad1fe,
    name: "email-settings-token___pl"
  }, {
    path: "/pl/order/:token?",
    component: _cb1f3282,
    name: "order-token___pl",
    children: [{
      path: "confirmation",
      component: _5dfe61b5,
      name: "order-token-confirmation___pl"
    }, {
      path: "payment",
      component: _18e32994,
      name: "order-token-payment___pl"
    }, {
      path: "return/:id?",
      component: _59c880db,
      name: "order-token-return-id___pl"
    }]
  }, {
    path: "/da/store/:slug?/write-review/:orderId?",
    component: _49dce10c,
    name: "store-slug-write-review-orderId___da"
  }, {
    path: "/de/store/:slug?/write-review/:orderId?",
    component: _49dce10c,
    name: "store-slug-write-review-orderId___de"
  }, {
    path: "/es/store/:slug?/write-review/:orderId?",
    component: _49dce10c,
    name: "store-slug-write-review-orderId___es"
  }, {
    path: "/fr/store/:slug?/write-review/:orderId?",
    component: _49dce10c,
    name: "store-slug-write-review-orderId___fr"
  }, {
    path: "/it/store/:slug?/write-review/:orderId?",
    component: _49dce10c,
    name: "store-slug-write-review-orderId___it"
  }, {
    path: "/nl/store/:slug?/write-review/:orderId?",
    component: _49dce10c,
    name: "store-slug-write-review-orderId___nl"
  }, {
    path: "/pl/store/:slug?/write-review/:orderId?",
    component: _49dce10c,
    name: "store-slug-write-review-orderId___pl"
  }, {
    path: "/es/marketplace/:categoryPath*",
    component: _035481d2,
    props: {"isMarketplacePage":true,"type":"storefronts","mode":"marketplace"},
    name: "marketplace___es"
  }, {
    path: "/it/marketplace/:categoryPath*",
    component: _035481d2,
    props: {"isMarketplacePage":true,"type":"storefronts","mode":"marketplace"},
    name: "marketplace___it"
  }, {
    path: "/da/marketplace/:categoryPath*",
    component: _035481d2,
    props: {"isMarketplacePage":true,"type":"storefronts","mode":"marketplace"},
    name: "marketplace___da"
  }, {
    path: "/pl/marketplace/:categoryPath*",
    component: _035481d2,
    props: {"isMarketplacePage":true,"type":"storefronts","mode":"marketplace"},
    name: "marketplace___pl"
  }, {
    path: "/fr/marketplace/:categoryPath*",
    component: _035481d2,
    props: {"isMarketplacePage":true,"type":"storefronts","mode":"marketplace"},
    name: "marketplace___fr"
  }, {
    path: "/de/marketplace/:categoryPath*",
    component: _035481d2,
    props: {"isMarketplacePage":true,"type":"storefronts","mode":"marketplace"},
    name: "marketplace___de"
  }, {
    path: "/nl/marketplace/:categoryPath*",
    component: _035481d2,
    props: {"isMarketplacePage":true,"type":"storefronts","mode":"marketplace"},
    name: "marketplace___nl"
  }, {
    path: "/es/listings/:categoryPath*",
    component: _035481d2,
    props: {"isListingsPage":true,"type":"listings","mode":"marketplace"},
    name: "listings___es"
  }, {
    path: "/it/listings/:categoryPath*",
    component: _035481d2,
    props: {"isListingsPage":true,"type":"listings","mode":"marketplace"},
    name: "listings___it"
  }, {
    path: "/da/listings/:categoryPath*",
    component: _035481d2,
    props: {"isListingsPage":true,"type":"listings","mode":"marketplace"},
    name: "listings___da"
  }, {
    path: "/pl/listings/:categoryPath*",
    component: _035481d2,
    props: {"isListingsPage":true,"type":"listings","mode":"marketplace"},
    name: "listings___pl"
  }, {
    path: "/fr/listings/:categoryPath*",
    component: _035481d2,
    props: {"isListingsPage":true,"type":"listings","mode":"marketplace"},
    name: "listings___fr"
  }, {
    path: "/de/listings/:categoryPath*",
    component: _035481d2,
    props: {"isListingsPage":true,"type":"listings","mode":"marketplace"},
    name: "listings___de"
  }, {
    path: "/nl/listings/:categoryPath*",
    component: _035481d2,
    props: {"isListingsPage":true,"type":"listings","mode":"marketplace"},
    name: "listings___nl"
  }, {
    path: "/es/search/:categoryPath*",
    component: _035481d2,
    props: {"isSearchPage":true,"type":"listings","mode":"marketplace"},
    name: "search___es"
  }, {
    path: "/it/search/:categoryPath*",
    component: _035481d2,
    props: {"isSearchPage":true,"type":"listings","mode":"marketplace"},
    name: "search___it"
  }, {
    path: "/da/search/:categoryPath*",
    component: _035481d2,
    props: {"isSearchPage":true,"type":"listings","mode":"marketplace"},
    name: "search___da"
  }, {
    path: "/pl/search/:categoryPath*",
    component: _035481d2,
    props: {"isSearchPage":true,"type":"listings","mode":"marketplace"},
    name: "search___pl"
  }, {
    path: "/fr/search/:categoryPath*",
    component: _035481d2,
    props: {"isSearchPage":true,"type":"listings","mode":"marketplace"},
    name: "search___fr"
  }, {
    path: "/de/search/:categoryPath*",
    component: _035481d2,
    props: {"isSearchPage":true,"type":"listings","mode":"marketplace"},
    name: "search___de"
  }, {
    path: "/nl/search/:categoryPath*",
    component: _035481d2,
    props: {"isSearchPage":true,"type":"listings","mode":"marketplace"},
    name: "search___nl"
  }, {
    path: "/es/wall/:categoryPath*",
    component: _035481d2,
    props: {"isWallPage":true,"type":"listings","mode":"marketplace"},
    name: "wall___es"
  }, {
    path: "/it/wall/:categoryPath*",
    component: _035481d2,
    props: {"isWallPage":true,"type":"listings","mode":"marketplace"},
    name: "wall___it"
  }, {
    path: "/da/wall/:categoryPath*",
    component: _035481d2,
    props: {"isWallPage":true,"type":"listings","mode":"marketplace"},
    name: "wall___da"
  }, {
    path: "/pl/wall/:categoryPath*",
    component: _035481d2,
    props: {"isWallPage":true,"type":"listings","mode":"marketplace"},
    name: "wall___pl"
  }, {
    path: "/fr/wall/:categoryPath*",
    component: _035481d2,
    props: {"isWallPage":true,"type":"listings","mode":"marketplace"},
    name: "wall___fr"
  }, {
    path: "/de/wall/:categoryPath*",
    component: _035481d2,
    props: {"isWallPage":true,"type":"listings","mode":"marketplace"},
    name: "wall___de"
  }, {
    path: "/nl/wall/:categoryPath*",
    component: _035481d2,
    props: {"isWallPage":true,"type":"listings","mode":"marketplace"},
    name: "wall___nl"
  }, {
    path: "/da/store/:slug/signup",
    component: _3fd83ee2,
    name: "storefront-signup___da"
  }, {
    path: "/de/store/:slug/signup",
    component: _3fd83ee2,
    name: "storefront-signup___de"
  }, {
    path: "/es/store/:slug/signup",
    component: _3fd83ee2,
    name: "storefront-signup___es"
  }, {
    path: "/fr/store/:slug/signup",
    component: _3fd83ee2,
    name: "storefront-signup___fr"
  }, {
    path: "/it/store/:slug/signup",
    component: _3fd83ee2,
    name: "storefront-signup___it"
  }, {
    path: "/nl/store/:slug/signup",
    component: _3fd83ee2,
    name: "storefront-signup___nl"
  }, {
    path: "/pl/store/:slug/signup",
    component: _3fd83ee2,
    name: "storefront-signup___pl"
  }, {
    path: "/da/store/:slug/collection/:collectionslug",
    component: _d419fcaa,
    name: "storefront-collection___da"
  }, {
    path: "/da/store/:slug/listings/:listingId",
    component: _96f4d604,
    name: "product___da"
  }, {
    path: "/da/store/:slug/write-review/:orderId",
    component: _49dce10c,
    name: "storefront-write-review___da"
  }, {
    path: "/de/store/:slug/collection/:collectionslug",
    component: _d419fcaa,
    name: "storefront-collection___de"
  }, {
    path: "/de/store/:slug/listings/:listingId",
    component: _96f4d604,
    name: "product___de"
  }, {
    path: "/de/store/:slug/write-review/:orderId",
    component: _49dce10c,
    name: "storefront-write-review___de"
  }, {
    path: "/es/store/:slug/collection/:collectionslug",
    component: _d419fcaa,
    name: "storefront-collection___es"
  }, {
    path: "/es/store/:slug/listings/:listingId",
    component: _96f4d604,
    name: "product___es"
  }, {
    path: "/es/store/:slug/write-review/:orderId",
    component: _49dce10c,
    name: "storefront-write-review___es"
  }, {
    path: "/fr/store/:slug/collection/:collectionslug",
    component: _d419fcaa,
    name: "storefront-collection___fr"
  }, {
    path: "/fr/store/:slug/listings/:listingId",
    component: _96f4d604,
    name: "product___fr"
  }, {
    path: "/fr/store/:slug/write-review/:orderId",
    component: _49dce10c,
    name: "storefront-write-review___fr"
  }, {
    path: "/it/store/:slug/collection/:collectionslug",
    component: _d419fcaa,
    name: "storefront-collection___it"
  }, {
    path: "/it/store/:slug/listings/:listingId",
    component: _96f4d604,
    name: "product___it"
  }, {
    path: "/it/store/:slug/write-review/:orderId",
    component: _49dce10c,
    name: "storefront-write-review___it"
  }, {
    path: "/nl/store/:slug/collection/:collectionslug",
    component: _d419fcaa,
    name: "storefront-collection___nl"
  }, {
    path: "/nl/store/:slug/listings/:listingId",
    component: _96f4d604,
    name: "product___nl"
  }, {
    path: "/nl/store/:slug/write-review/:orderId",
    component: _49dce10c,
    name: "storefront-write-review___nl"
  }, {
    path: "/pl/store/:slug/collection/:collectionslug",
    component: _d419fcaa,
    name: "storefront-collection___pl"
  }, {
    path: "/pl/store/:slug/listings/:listingId",
    component: _96f4d604,
    name: "product___pl"
  }, {
    path: "/pl/store/:slug/write-review/:orderId",
    component: _49dce10c,
    name: "storefront-write-review___pl"
  }, {
    path: "/trademart/invites/:token?/connect/:id?",
    component: _ffaf7304,
    name: "trademart-invites-token-connect-id___en"
  }, {
    path: "/es/store/:slug/:categoryPath*",
    component: _d419fcaa,
    name: "storefront___es"
  }, {
    path: "/it/store/:slug/:categoryPath*",
    component: _d419fcaa,
    name: "storefront___it"
  }, {
    path: "/da/store/:slug/:categoryPath*",
    component: _d419fcaa,
    name: "storefront___da"
  }, {
    path: "/pl/store/:slug/:categoryPath*",
    component: _d419fcaa,
    name: "storefront___pl"
  }, {
    path: "/fr/store/:slug/:categoryPath*",
    component: _d419fcaa,
    name: "storefront___fr"
  }, {
    path: "/de/store/:slug/:categoryPath*",
    component: _d419fcaa,
    name: "storefront___de"
  }, {
    path: "/nl/store/:slug/:categoryPath*",
    component: _d419fcaa,
    name: "storefront___nl"
  }, {
    path: "/brands/:type",
    component: _0af3b87a,
    name: "brands-type___en"
  }, {
    path: "/email-settings/:token?",
    component: _73fad1fe,
    name: "email-settings-token___en"
  }, {
    path: "/order/:token?",
    component: _cb1f3282,
    name: "order-token___en",
    children: [{
      path: "confirmation",
      component: _5dfe61b5,
      name: "order-token-confirmation___en"
    }, {
      path: "payment",
      component: _18e32994,
      name: "order-token-payment___en"
    }, {
      path: "return/:id?",
      component: _59c880db,
      name: "order-token-return-id___en"
    }]
  }, {
    path: "/page/:slug?",
    component: _a438c924,
    name: "page-slug___en"
  }, {
    path: "/pay/:slug?",
    component: _a3457da2,
    name: "pay-slug___en"
  }, {
    path: "/retailers/:type",
    component: _456d834e,
    name: "retailers-type___en"
  }, {
    path: "/store/:slug?/about",
    component: _763b26e6,
    name: "store-slug-about___en"
  }, {
    path: "/store/:slug?/signup",
    component: _3fd83ee2,
    name: "store-slug-signup___en"
  }, {
    path: "/store/:slug?/write-review/:orderId?",
    component: _49dce10c,
    name: "store-slug-write-review-orderId___en"
  }, {
    path: "/marketplace/:categoryPath*",
    component: _035481d2,
    props: {"isMarketplacePage":true,"type":"storefronts","mode":"marketplace"},
    name: "marketplace___en"
  }, {
    path: "/listings/:categoryPath*",
    component: _035481d2,
    props: {"isListingsPage":true,"type":"listings","mode":"marketplace"},
    name: "listings___en"
  }, {
    path: "/search/:categoryPath*",
    component: _035481d2,
    props: {"isSearchPage":true,"type":"listings","mode":"marketplace"},
    name: "search___en"
  }, {
    path: "/wall/:categoryPath*",
    component: _035481d2,
    props: {"isWallPage":true,"type":"listings","mode":"marketplace"},
    name: "wall___en"
  }, {
    path: "/store/:slug/signup",
    component: _3fd83ee2,
    name: "storefront-signup___en"
  }, {
    path: "/store/:slug/collection/:collectionslug",
    component: _d419fcaa,
    name: "storefront-collection___en"
  }, {
    path: "/store/:slug/listings/:listingId",
    component: _96f4d604,
    name: "product___en"
  }, {
    path: "/store/:slug/write-review/:orderId",
    component: _49dce10c,
    name: "storefront-write-review___en"
  }, {
    path: "/store/:slug/:categoryPath*",
    component: _d419fcaa,
    name: "storefront___en"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
